@for (secondLevelCategory of category().children; track $index; let first = $first) {
  <p class="sub-category-header" [class.first]="first">
    {{ secondLevelCategory.label }}
  </p>

  @defer (on viewport) {
    <div class="cart-items">
      @for (item of secondLevelCategory.items; track $index + item.sku) {
        <ui-order-item
          [product]="item.productData"
          [productItem]="item"
          (quantityChanged)="itemQuantityChanged.emit($event)"
          (removed)="itemRemoved.emit($event)"
          [position]="$index"
        ></ui-order-item>
      }
    </div>
  } @placeholder (minimum 400ms) {
    <div class="cart-items">
      @for (i of skeletonRenderArray(); track $index) {
        <ui-shopping-list-item-skeleton
          [displayListView]="!isMobile()"
        ></ui-shopping-list-item-skeleton>
      }
    </div>
  }
}
